import React, { Component } from 'react';
import {Map, Marker, GoogleApiWrapper} from 'google-maps-react';
import './Main.css'


export class MapContainer extends Component {
   render() {
      return (
         <Map  
         google={this.props.google}
         zoom={17}
         initialCenter={{ lat: 44.758324, lng: 19.213294}}
         style={{height:'550px'}}>
             <Marker 
                  position={{ lat: 44.758324, lng: 19.213294}} 
             />
          </Map>
      );
   }
}
export default GoogleApiWrapper({
       apiKey: ('AIzaSyD5quFnqCmWcp5KUOTqMveYDXWNYJe6wnc')
})(MapContainer)